import { render } from "./Home.vue?vue&type=template&id=451d4d1f&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=451d4d1f&scoped=true&lang=scss"

import exportComponent from "C:\\proyectos-alliances\\alliance.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-451d4d1f"]])

export default __exports__